module.exports = __webpack_public_path__ + "static/media/shell.1729fbbc.jpg";